export default "__VITE_ASSET__D_ZaUl16__"